import React from 'react';

function About() {
  return (
    <section id="about" className="py-20 lg:py-28 bg-[#FAFCFE] border-b border-brand-200/70">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">

          {/* Left Column: Cafe Atmosphere Photo */}
          <div className="lg:col-span-6 relative">
            <div className="relative rounded-3xl overflow-hidden bg-white border border-brand-200/80 shadow-lg p-2.5 sm:p-3">
              <div className="rounded-2xl overflow-hidden aspect-[4/3] bg-brand-100 relative">
                <img
                  src="/icon.png"
                  alt="DA'VI Greek Yogurt"
                  className="w-full h-full object-cover transform hover:scale-102 transition-transform duration-700"
                />
                
                {/* Floating Aegean Blue architectural badge */}
                <div className="absolute top-4 left-4 bg-white/95 backdrop-blur-md px-3.5 py-1.5 rounded-full border border-brand-100 shadow-xs flex items-center space-x-2">
                  <span className="w-2 h-2 rounded-full bg-brand-500"></span>
                  <span className="text-[11px] font-serif uppercase tracking-widest text-brand-800">
                    Artisanal Kitchen
                  </span>
                </div>
              </div>
            </div>

            {/* Subtle decorative Greek blue accent block */}
            <div className="absolute -bottom-4 -right-4 w-24 h-24 rounded-3xl bg-brand-200/50 -z-10 blur-xl"></div>
          </div>

          {/* Right Column: Our Story Content (exact match to image) */}
          {/* <div className="lg:col-span-6 space-y-6">
            
     
            <div className="inline-flex items-center gap-2 text-brand-600">
              <span className="text-[11px] uppercase tracking-[0.25em] font-bold">
                Our Story
              </span>
              <svg className="w-4 h-4 text-brand-500 transform rotate-12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8">
                <path d="M4 20c4-4 8-9 16-16" />
                <path d="M10 8c-2 0-3 2-3 2s2 1 3 0" fill="currentColor" fillOpacity="0.25" />
                <path d="M14 12c-2 0-3 2-3 2s2 1 3 0" fill="currentColor" fillOpacity="0.25" />
              </svg>
            </div>

           
            <h2 className="font-serif text-3xl sm:text-5xl text-brand-900 leading-[1.15] font-normal tracking-tight">
              Simple. Real. <br />
              <span className="italic text-brand-600 font-light">Good Together.</span>
            </h2>

         
            <div className="space-y-4 text-brand-700/90 leading-relaxed font-light">
              <p className="text-sm sm:text-base">
                DA'VI was born from the love of good food and good company. Inspired by Greek living, we create a space where you can slow down, nourish your body, and enjoy the little things.
              </p>
              
              <p className="text-xs sm:text-sm text-brand-600/80 leading-relaxed">
                เราตั้งใจนำเสนอรสชาติที่บริสุทธิ์จากธรรมชาติ ด้วยกรรมวิธีดั้งเดิมที่บ่มและกรองอย่างช้าๆ จนได้เนื้อกรีกโยเกิร์ตที่เข้มข้น โปรตีนสูง ปราศจากสารปรุงแต่ง จับคู่กับครัวซองต์เนยฝรั่งเศสแท้ อบใหม่ส่งกลิ่นหอมกรุ่น เพื่อให้ทุกช่วงเวลาคือความอบอุ่นและสุขใจ
              </p>
            </div>

           
            <div className="grid grid-cols-2 gap-4 pt-2">
              <div className="p-4 bg-white rounded-2xl border border-brand-200/70 shadow-2xs">
                <span className="font-serif text-xl sm:text-2xl font-medium text-brand-800 block">Homemade</span>
                <span className="text-[11px] text-brand-500 tracking-wide font-normal">ทำสดใหม่วันต่อวัน 100%</span>
              </div>
              <div className="p-4 bg-white rounded-2xl border border-brand-200/70 shadow-2xs">
                <span className="font-serif text-xl sm:text-2xl font-medium text-brand-800 block">No Additives</span>
                <span className="text-[11px] text-brand-500 tracking-wide font-normal">ไร้สารกันบูดและสารแต่งสี</span>
              </div>
            </div>

           
            <div className="pt-2">
              <a
                href="#builder"
                className="inline-flex items-center px-8 py-3 rounded-full border border-brand-600 text-brand-600 hover:bg-brand-600 hover:text-white transition-all text-xs uppercase tracking-[0.2em] font-semibold shadow-2xs"
              >
                Learn More
              </a>
            </div>

          </div> */}

        </div>
      </div>
    </section>
  );
}

export default About;
